(function () {
  function updateStyliticsAccessibility() {
    const items = document.querySelectorAll('.stylitics-hotspots-img-container');

    items.forEach((item) => {
      const hotspotButton = item.querySelector('[data-testid="stylitics-hotspots-dot-focus-area"]');
      const itemLink = item.querySelector('a[data-testid="stylitics-hotspots-item-label"]');
      const itemNameEl = item.querySelector('.stylitics-hotspots-label-name');
      const priceEl = item.querySelector('[data-testid="stylitics-ui-regular-price"]');

      const itemName = itemNameEl?.textContent?.trim();
      const price = priceEl?.textContent?.trim();

      if (hotspotButton && itemName) {
        hotspotButton.setAttribute('aria-label', `Show bundle item details for ${itemName}`);
      }

      if (itemLink && itemName) {
        const linkLabel = price
          ? `Shop bundle item ${itemName}, price ${price}. Opens in a new tab`
          : `Shop bundle item ${itemName}. Opens in a new tab`;

        itemLink.setAttribute('aria-label', linkLabel);
      }
    });
  }

  function observeStylitics() {
    const containers = document.querySelectorAll('.stylitics-hotspots-collage, #stylitics-widget-container');

    if (!containers.length) return;

    updateStyliticsAccessibility();

    containers.forEach((container) => {
      const observer = new MutationObserver(() => {
        updateStyliticsAccessibility();
      });

      observer.observe(container, {
        childList: true,
        subtree: true,
      });
    });
  }

  document.addEventListener('DOMContentLoaded', observeStylitics);
  window.addEventListener('load', observeStylitics);
})();